import axios from 'axios';

/**
 * 获取销售机构
 */
function branches() {
  return axios.get('apply/v1/input/salebranchs?')
}

/**
 * 获取字典
 */
function dic(data) {
  return axios.get('renewal/v1/renewal/terminology?', {params: data})
}

export default {
  branches,
  dic
};



// WEBPACK FOOTER //
// ./src/interface.js